module.exports = __webpack_public_path__ + "img/station_expanded_pin_fr.28759011.png";